import {Component, OnInit} from '@angular/core';
import {StepChapterComponent} from "../../step/step.chapter.component";
import {slideInAnimation} from "../../step/step.animations";
import {StepService} from "../../services/step.service";
import {PortalService} from "../../services/portal.service";
import {ChildrenOutletContexts, Router} from "@angular/router";
import {ActivatedRoute} from "@angular/router";

/**
 * Generic component for holding severeal steps as one chapter.
 */
@Component({
    templateUrl: './einstieg.chapter.component.html',
    selector: 'app-einstieg-chapter',
    animations: [
        slideInAnimation
    ],
    standalone: false
})
export class EinstiegChapterComponent extends StepChapterComponent implements OnInit {
  /**
   * placeholder for portalname in welcome text
   */
  welcomePlaceholder: any = {};

  /**
   * constructor
   * @param router
   * @param route
   * @param portalService
   * @param stepService
   * @param contexts
   */

  constructor(protected router: Router, protected route: ActivatedRoute, protected stepService: StepService, protected portalService: PortalService, protected contexts: ChildrenOutletContexts){
    super(router, route, stepService, portalService, contexts);
  };

  ngOnInit() {
    super.ngOnInit();

    //init Placeholder
    if(this.portalService.getConfig('embed.portal.welcometext')) {
      this.welcomePlaceholder = {
        portalPlaceholder: ' ' + this.portalService.getConfig('embed.portal.welcometext')
      }
    }
    else {
      this.welcomePlaceholder = {
        portalPlaceholder: ''
      }
    }
  }

}
